import React from "react";
import classNames from "classnames";

import Typography from "@/components/Typography";

import { EpisodeTrackListInterface } from "./EpisodeTrackList.interface";
import styles from "./EpisodeTracklist.module.scss";

export const EpisodeTracklist: React.FC<EpisodeTrackListInterface> = ({
  tracklist,
  style,
  className,
}) => {
  return (
    <ol
      className={classNames(styles.tracklist, className)}
      style={{ height: style.height + "px" }}
    >
      {tracklist.map((track, index) => (
        <li
          className={styles.track}
          key={`${index}-${track.title}-${track.author}`}
        >
          <Typography variant="medium" className={styles.title}>
            {track?.title}
          </Typography>

          <Typography variant="medium" className={styles.artist}>
            {track.author}
          </Typography>
        </li>
      ))}
    </ol>
  );
};

export default EpisodeTracklist;
